import type { DashboardWidgetType } from './types';

const VIZ_WIDGET_TYPES: DashboardWidgetType[] = [
  'viz_tabs',
  'chart_bar',
  'chart_line',
  'chart_area',
  'chart_donut',
  'chart_radar',
  'chart_scatter',
  'chart_treemap',
  'calendar_heatmap',
];

export function isVizWidgetType(t: DashboardWidgetType): boolean {
  return VIZ_WIDGET_TYPES.includes(t);
}
